/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardResponse } from '../../models/dashboard-response';
import { DashboardSearchModel } from '../../models/dashboard-search-model';

export interface DashboardDashboardSearchPost$Json$Params {
      body?: DashboardSearchModel
}

export function dashboardDashboardSearchPost$Json(http: HttpClient, rootUrl: string, params?: DashboardDashboardSearchPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<DashboardResponse>> {
  const rb = new RequestBuilder(rootUrl, dashboardDashboardSearchPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<DashboardResponse>;
    })
  );
}

dashboardDashboardSearchPost$Json.PATH = '/Dashboard/DashboardSearch';
